import server from './interceptor'
// import store from '@/store'
import { crypto } from '../utils/crypto'

const _S = 'NcStvpTAmIquJJtznBdnYKhOiB6Clndr'

function request (url, params = {}, method) {
  // 所有请求添加
  const gameParams = JSON.parse(window.localStorage.getItem('sdkParams') || '{}')
  const logData = gameParams.logData || {}

  // 线下环境添加可携带额外参数
  if (process.env.NODE_ENV !== 'production') {
    const extra = JSON.parse(decodeURIComponent(gameParams.extraParams || '') || '{}')
    params = { ...params, ...extra, country_code: 'US' }
  }

  let headers = {}
  // if (gameParams.gid === '60004') {
  //   params.app_id = gameParams.gid
  // } else {
  //   params.app_id = 'web'
  // }
  params.app_id = gameParams.gid
  params.os = 'web'
  params.device_id = params.device_id || logData.properties?.device_id || 'web'
  // params.from = 'web'
  params.lang = gameParams.lang
  // 是否开启未成年人流程
  if (!('minor_verification' in params)) params.minor_verification = 1

  const sign = crypto(params, _S)
  headers.auth = sign

  if (url.substr(0, 1) === '/') {
    if (process.env.VUE_APP_API_URL) {
      url = process.env.VUE_APP_API_URL + url
    }
  } else if (url.substr(0, 3) === 'ame') {
    // ame 接口使用直连  url = ame/gid/do
    const gid = url.split('/')[1]
    if (gid) {
      url = (process.env[`VUE_APP_AME_API_${gid}`] || process.env.VUE_APP_AME_API_DEFAULT) + url.split(gid)[1]
      headers = {}
    }
  } else if (url.substr(0, 3) === 'AME') {
    url = process.env.VUE_APP_AME_API_DEFAULT + url.replace('AME', '')
    headers = {}
  } else {
    params = {}
    headers = {}
  }

  return new Promise((resolve, reject) => {
    let data = {}
    // get
    if (method === 'get') data = { params }
    // post
    if (method === 'post') data = { data: params }
    // delete
    if (method === 'delete') data = { params }
    server({
      url,
      method,
      ...data,
      headers
    }).then(res => {
      resolve(res)
    }).catch(err => {
      reject(err)
    })
  })
}

function get (url, params = {}) {
  return request(url, params, 'get')
}

function post (url, params = {}) {
  return request(url, params, 'post')
}

function serverDelete (url, params = {}) {
  return request(url, params, 'delete')
}

export default {
  get,
  post,
  delete: serverDelete
}
